import { getDateDistance } from '../../utilities'
import { PERMS } from '../../hooks/useAccess'

const ANY_STATUS = 'ANY CLIENT STATUS'
const CLIENT = 'CLIENT'
const PROSPECT = 'PROSPECT'
const LEAD = 'LEAD'
export const CLIENT_STATUS_OPTIONS = [ANY_STATUS, CLIENT, PROSPECT, LEAD]

const ALL_CLIENTS = 'ALL CLIENTS'
const MY_CLIENTS = 'MY CLIENTS'
export const CLIENT_FILTER_OPTIONS = [ALL_CLIENTS, MY_CLIENTS]

const DATE_CREATED_EARLIEST = 'DATE CREATED (Earliest - Latest)'
const DATE_CREATED_LATEST = 'DATE CREATED (Latest - Earliest)'
export const CLIENT_SORT_OPTIONS = [DATE_CREATED_EARLIEST, DATE_CREATED_LATEST]

export const filterStatuses = (users, filter, statuses) => {
  switch (filter) {
    case CLIENT:
      const clientStatus = statuses.find(({ name }) => name === 'Client')
      return users.filter(user => user.status_id === clientStatus?.id)
    case PROSPECT:
      const prospectStatus = statuses.find(({ name }) => name === 'Prospect')
      return users.filter(user => user.status_id === prospectStatus?.id)
    case LEAD:
      const leadStatus = statuses.find(({ name }) => name === 'Lead')
      return users.filter(user => user.status_id === leadStatus?.id)
    case ANY_STATUS:
      return users
    default:
      console.error('Unknown filter selected', filter)
      return []
  }
}

export const filterPermissions = (
  hasPermission,
  users,
  external,
  currentUser
) => {
  let copy = [...users]

  if (external) {
    if (
      !hasPermission(PERMS.ContactsAudit) &&
      hasPermission(PERMS.ContactsOwn)
    ) {
      copy = copy.filter(user => user.owner_id === currentUser?.id)
    }
  }

  return copy
}

const sortDateCreated = earliestFirst => (a, b) => {
  const aCreated = new Date(a.created_at)
  const bCreated = new Date(b.created_at)
  const diff = aCreated - bCreated
  return earliestFirst ? diff : -diff
}

const getSortingMethod = sort => {
  switch (sort) {
    case DATE_CREATED_EARLIEST:
      return sortDateCreated(true)
    case DATE_CREATED_LATEST:
      return sortDateCreated(false)
    default:
      console.error('Unknown sorting method', sort)
      return () => 0
  }
}

export const sortUsers = (users, sort) => {
  const copy = [...users]
  copy.sort(getSortingMethod(sort))
  return copy
}

const countDateDistances = dists => {
  let due = 0
  let soon = 0
  let good = 0

  dists.forEach(dist => {
    if (dist === -1) {
      due++
    } else if (dist === 1) {
      good++
    } else {
      soon++
    }
  })

  return { due, soon, good }
}

export const nameSorter = () => {
  return (a, b) => {
    const aName = a.original.name.trim()
    const bName = b.original.name.trim()
    return aName.localeCompare(bName)
  }
}

export const statusSorter = userStatuses => {
  return (a, b) => {
    const aStatusIndex = userStatuses.findIndex(
      status => status.id === a.original.status_id
    )
    const bStatusIndex = userStatuses.findIndex(
      status => status.id === b.original.status_id
    )
    return aStatusIndex - bStatusIndex
  }
}

export const taskSorter = () => {
  return (a, b) => {
    const aRelative = a.original.tasks.map(task =>
      getDateDistance(task.due_date)
    )
    const bRelative = b.original.tasks.map(task =>
      getDateDistance(task.due_date)
    )

    const { due: aDue, soon: aSoon, good: aGood } = countDateDistances(
      aRelative
    )
    const { due: bDue, soon: bSoon, good: bGood } = countDateDistances(
      bRelative
    )

    // Check num due
    const dueDiff = aDue - bDue
    if (dueDiff !== 0) {
      return dueDiff
    }

    //  Check num at risk
    const soonDiff = aSoon - bSoon
    if (soonDiff !== 0) {
      return soonDiff
    }

    // Check num farther away
    const goodDiff = aGood - bGood
    return goodDiff
  }
}
